export default __webpack_public_path__ + "static/media/cloudy-night.bdd63c6a.svg";